import { Component } from "react";
import Arrow from "./arrow";
import logoUB from "@/images/logoUB.png";
import logoUBFC from "@/images/UBFC-uB.png";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() { 
    return (
      <footer className="bg-gray-darkest text-white mt-2 pt-6 flex-shrink-0">
        <div className="container mx-auto w-3/4 flex flex-col items-stretch py-2">
          <div className="flex justify-between items-center gap-6 flex-wrap">
            <img src={logoUB} alt="Logo UB" className="w-24"/>
            <div className="text-sm flex-grow">
              <p>Université de Bourgogne • Maison de l’université • Esplanade Erasme</p>
              <p>BP 27877 • 21078 Dijon cedex • FRANCE</p>
              <p>Tél. : +33 3 80 39 50 00</p>
            </div>
            <a href="https://www.u-bourgogne.fr/universite/organisation/ufr-instituts-ecoles" className="uppercase font-t-semibold flex"><Arrow />UFR, Instituts, Ecoles</a>
            <a href="https://www.u-bourgogne.fr/recherche-scientifique.html" className="uppercase font-t-semibold flex"><Arrow />Recherche scientifique</a>
            <img src={logoUBFC} alt="logo Université Bourgogne Franche Comté" />
          </div>
          <hr className="border border-orange w-full my-4 px-4" />
          <p className="text-center">© Université de Bourgogne 2021 • <a href="https://www.u-bourgogne.fr/non-categorise/mentions-legales">Mentions légales</a></p>
        </div>
      </footer>
    );
  }
}
 
export default Footer;